/*
 * Module for Direct Deposit step
 */
rs.module("content/retirementapplication/directdeposit",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, getBankUrl) {
            const routingNumberInput = $.js(jsSelectors.routingNumber);
            const bankNameInput = $.js(jsSelectors.bankName);

            if (routingNumberInput && bankNameInput) {
                // Validate routing number format (9 digits)
                routingNumberInput.on('blur', function () {
                    const value = $(this).val().replace(/\D/g, ''); // Remove non-digits
                    
                    if (value.length === 9) {
                        $.post(getBankUrl, { abaNumber: routingNumberInput.val() })
                            .done(function (result) {
                                console.log(result);
                                bankNameInput.val(result.bankName);
                            })
                            .fail(function () {
                                bankNameInput.val('Unknown Bank');
                            });
                    }
                });

                routingNumberInput.on('input', function () {
                    // Only allow numeric input
                    $(this).val($(this).val().replace(/\D/g, ''));
                    
                    // Limit to 9 characters
                    if ($(this).val().length > 9) {
                        $(this).val($(this).val().slice(0, 9));
                    }

                    bankNameInput.val('');
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
